/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/core-client/js/core-client/ui/core/View'
], function(View) {

	var EmptyView = View.extend({
		templateString: '<div class="datawidget empty-view" style="padding: 4px;text-align: center;"><div class="dropitemshere"></div>Drag data items here</div>',

		init: function() {
			EmptyView.inherited('init', this, arguments);
		},

		getRenderer: function() {
			return 'dashboard-analytics/visualizations/renderer/empty/EmptyRenderer';
		}
	});

	return EmptyView;
});
